import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BannerService {
  private errorSubject = new BehaviorSubject<any>({});
  error$ = this.errorSubject.asObservable(); // Observable to track error messages

  // Notify when an error occurs
  notifyError(message: string, bannerType: string, component: string, callback?: any): void {
    this.errorSubject.next({ message, bannerType,component,callback });
  }

  // Method to clear the error (used after refresh)
  clearError() {
    this.errorSubject.next({});

  }
}
